import type { ParsedBrickCell } from "./AsciiBrickMapParser.js";

/**
 * 생성된 벽돌 셀의 일부를 미스터리(?) 벽돌로 마킹 — 순수(Phaser 비의존), 결정론(rng 주입).
 *
 * normal 블록만 대상으로 삼는다. 이미 boss/hard/special 등 비-normal인 셀은
 * 자동 제외 — 한 셀이 다른 특수 벽돌이면서 mystery일 수 없다. normal 블록의 `kind`만 mystery로
 * 바꾸고 `hpMultiplier`(=칸수)는 보존한다 — 미스터리 블록의 HP는 일반 벽돌과 동일(요건), 보상만 특수.
 * 입력 배열은 변경하지 않고 새 배열을 반환한다. seed salt로 위치를 결정론화한다.
 */
export interface MarkMysteryOptions {
  /** 셀별 미스터리 마킹 확률(0~1). 0이면 마킹 0. */
  readonly chance: number;
  /** 챕터당 미스터리 벽돌 최대 개수. */
  readonly maxPerChapter: number;
}

/**
 * normal 셀을 순회하며 chance로 mystery 마킹(상한 maxPerChapter). rng는 seed 파생으로 주입해
 * 같은 (cells, rng seed) → 같은 결과. boss/hard 등 비-normal 셀은 건드리지 않는다.
 */
export function markMysteryBricks(
  cells: readonly ParsedBrickCell[],
  rng: () => number,
  opts: MarkMysteryOptions,
): ParsedBrickCell[] {
  const { chance, maxPerChapter } = opts;
  let count = 0;
  return cells.map((c) => {
    if (c.kind !== "normal" || count >= maxPerChapter || chance <= 0) {
      return { ...c };
    }
    if (rng() < chance) {
      count += 1;
      return { ...c, kind: "mystery" as const };
    }
    return { ...c };
  });
}
